module.exports = __webpack_public_path__ + "static/media/home-banner.0de6d58f.png";